import { compact } from 'lodash';
import { pickDefaultModelResult } from '../../../../common/model/data-point-pickers';
import { ModelEntityWithScores } from '../../../../common/model/output/scores/model-entity-data/types';
import { RenderItem } from '../../../../common/renderer/types';
import { seriesColorScale } from '../../../common/generic/global/colors';
import { ImpactChartDataSeries } from '../../../common/upright/model/output/scores/net-impact-chart/types';

export function toChartData(items: RenderItem[], entities: ModelEntityWithScores[]): ImpactChartDataSeries[] {
  const dataSeries = items.map((item, index): ImpactChartDataSeries | undefined => {
    const entity = entities.find(e => e.id === item.id && e.type === item.type);
    const modelResult = getModelResultOfRenderItem(item, entity);
    if (!modelResult || !entity) {
      return undefined;
    }
    return {
      impactScoresByTIVV: modelResult.impactScoresByTIVV,
      name: item.name || entity.name,
      id: entity.id,
      resultId: modelResult.resultId,
      type: entity.type,
      color: getColor(item, items.length, index),
      revenue: modelResult.revenue,
    };
  });
  return compact(dataSeries);
}

function getModelResultOfRenderItem(item: RenderItem, entity: ModelEntityWithScores | undefined) {
  if (!entity) {
    return undefined;
  }
  const modelResult =
    entity.modelResults.find(result => result.resultId === item.resultId) ||
    pickDefaultModelResult(entity.modelResults);
  return modelResult;
}

function getColor(item: RenderItem, itemCount: number, index: number) {
  if (itemCount === 1) {
    return undefined;
  }
  if (item.color) {
    return item.color;
  }
  return seriesColorScale(index);
}
